import { createSxStyles } from "../createSxStyles";
import type { InformationTooltipProps } from "./InformationTooltip";

export const useInformationTooltipStyles = (props: InformationTooltipProps) => {
    return createSxStyles({
        infoLogo: () => {
            const size = props.small ? 14 : 18;
            return {
                display: "flex",
                "& svg": {
                    width: size,
                    height: size,
                },
            };
        },
    });
};
